module.exports = __webpack_public_path__ + "img/bet_amount_icon.8a3aafd4.svg";